import { JioTranslateChainer, JioTranslateCore } from '@jiotranslate/core-beta';
import { BrowserExtensionPlugin } from './BrowserExtensionPlugin/BrowserExtensionPlugin';

export function JioTranslate(): JioTranslateChainer {
  return JioTranslateCore().use(BrowserExtensionPlugin());
}
